"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "theme", {
    enumerable: true,
    get: function() {
        return theme;
    }
});
var _breakpoints = require("./breakpoints");
var _Components = require("./Components/index");
var _Colors = require("./Colors/index");
var _Shadows = require("./Shadows/index");
var _Radius = require("./Radius/index");
var _Spacing = require("./Spacing/index");
var _styles = require("./styles");
var theme = {
    breakpoints: _breakpoints.breakpoints,
    colors: _Colors.defaultColors,
    shadows: _Shadows.defaultShadows,
    radii: _Radius.defaultRadius,
    space: _Spacing.defaultSpacing,
    components: _Components.components,
    textStyles: _styles.textStyles
};
